import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBasketball16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconBasketball16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.684 12.736A5.97 5.97 0 0 1 8.5 13.979V8.5h1.516a7.47 7.47 0 0 0 1.668 4.236M11.02 8.5a6.47 6.47 0 0 0 1.402 3.557A5.98 5.98 0 0 0 13.98 8.5zm2.96-1h-2.96a6.47 6.47 0 0 1 1.402-3.557A5.98 5.98 0 0 1 13.98 7.5m-3.963 0a7.47 7.47 0 0 1 1.668-4.236A5.97 5.97 0 0 0 8.5 2.021V7.5zM7.5 7.5V2.02a5.97 5.97 0 0 0-3.131 1.203A7.47 7.47 0 0 1 6.07 7.5zm-2.432 0a6.47 6.47 0 0 0-1.443-3.606A5.98 5.98 0 0 0 2.021 7.5zm-3.047 1h3.047a6.47 6.47 0 0 1-1.443 3.607A5.98 5.98 0 0 1 2.021 8.5m4.05 0H7.5v5.48a5.97 5.97 0 0 1-3.131-1.203A7.47 7.47 0 0 0 6.07 8.5M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBasketball16);
